export const getRnaIdFeature = (
  propertyType,
  propertyFeatures,
  unitFeatures
) => {
  const features =
    propertyType === 'whole' || propertyType === 'studio'
      ? propertyFeatures
      : unitFeatures;

  return features?.rnaId || null;
};

export default {
  getRnaIdFeature
};
